import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbUpWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_1121_18698)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.89592 0.799752C6.09378 0.578778 6.42342 0.535542 6.67157 0.698015C6.98073 0.900423 7.22656 1.25342 7.44904 1.75788C7.50553 1.88597 7.51545 2.02977 7.4771 2.16439L6.85916 4.33333H10.8001C11.1314 4.33333 11.4001 4.60196 11.4001 4.93333V6.53333C11.4001 6.6194 11.3815 6.70445 11.3458 6.78273L9.39577 11.0494C9.29815 11.263 9.0849 11.4 8.85006 11.4H3.00006C2.66869 11.4 2.40006 11.1314 2.40006 10.8V4.93333C2.40006 4.78563 2.45454 4.64312 2.55306 4.53308L5.89592 0.799752ZM0.606689 11.394L0.609661 8.09877L0.613318 4.79879L1.81332 4.80361L1.80669 11.3988L1.80006 11.3988L0.606689 11.394ZM6.20348 2.25517L3.60006 5.1627V10.2H8.46458L10.2001 6.40272V5.53333H6.06434C5.6659 5.53333 5.37814 5.15212 5.48731 4.76893L6.20348 2.25517Z",
				fill: "white",
				fillOpacity: .87
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1121_18698",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 12,
				height: 12,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgThumbUpWhite);
export { ForwardRef as ReactComponent };
